import { Circle, GeometryBase, Wedge, Line, Point, RevolveSurface, StraightLine, Torus, EllipseArc, Cone, Cylinder, EllipseSurface, GeneralRegion, BoolOpeType, GeneralSolid, PolygonIndex, Box, RegionFace, ExtrudeSolid, GeoRelation, ExtrudeSurface, Polygon, RectFace, Arc, SweeperSurface, SweeperSolid } from "tnbase";

import { Matrix4, Vector3 } from "three";

import { Glyph } from "opentype.js";
import { BlockPrimitive, EventHandlerBase, Primitive, PrimitiveType, TextPrimitive } from "pytha2";


/**
 * 渲染测试专用节点，测试用例请以函数的方式保存在文件中
 */
export class EHTestRender extends EventHandlerBase {

    addPrimitive(primitive: Primitive, geos: GeometryBase[]) {
        const storage = this.getPythaStorage();
        primitive.geos.push(...geos);
        let keys = Object.keys(primitive.renderItemDict);
        if (keys.length > 0) {
            let renderItem = primitive.renderItemDict[keys[0]];
            renderItem.geoElements = [];
            geos.forEach(geo => {
                let geoElementsLength = renderItem.geoElements.length;
                geo.getGeoElementsIdxList().forEach(idx => {
                    renderItem.geoElements.push(idx + geoElementsLength);
                })
            });
            if (primitive.isBoolPrimitive()) {
                primitive.renderItemDict[keys[0]].geoElements = [];
                primitive.renderItemDict[keys[0]].geoElements.push(0);
            }
        }

        primitive.temporary = false;
        storage.primitiveStore.primitiveDict[primitive.uuid] = primitive;
        primitive.needRedraw = true;
    }

    run(data?: {}): boolean {
        console.log("测试节点~~~~")
        // // this.lineRender();
        // this.sweeperRender();
        // this.sweeperSolidRender();


        // // this.textGenCircle();
        // //this.testFontBox("1324.23", 400, 0.7)

        // // this.sectionRender();
        // this.mockAxis();
        // // this.extrudeSur();
        // // this.generalRegion();


        // this.holeRegion();
        return true;
    }

    holeRegion() {
        let outCilcle = new Circle(new Point(0, 0, 0), 0.4 * 1000 / 2);
        let inCilcle = new Circle(new Point(0, 0, 0), 0.4 * 1000 / 2 - 0.02 * 1000);
        let regionface = new RegionFace();
        regionface.holes = [new RegionFace([inCilcle], new Vector3(1, 0, 0), new Point(0, 0, 0))];
        regionface.setRegionFace([outCilcle]);
        const p1 = new Primitive("RegionFace");
        this.addPrimitive(p1, [regionface]);

    }

    generalRegion() {
        const l1 = new Line(new Vector3(0, 0, 0), new Vector3(20, 0, 0));
        const l2 = new Line(new Vector3(20, 0, 0), new Vector3(10, 20, 0));
        const l3 = new Line(new Vector3(10, 20, 0), new Vector3(10, -20, 0));
        const l4 = new Line(new Vector3(10, -20, 0), new Vector3(0, 0, 0));

        const e1 = new ExtrudeSurface(l1);
        const e2 = new ExtrudeSurface(l2);
        const e3 = new ExtrudeSurface(l3);
        const e4 = new ExtrudeSurface(l4);
        const p1 = new Primitive("ExtrudeSurface");
        const p2 = new Primitive("ExtrudeSurface");
        const p3 = new Primitive("ExtrudeSurface");
        const p4 = new Primitive("ExtrudeSurface");
        this.addPrimitive(p1, [e1]);
        this.addPrimitive(p2, [e2]);
        this.addPrimitive(p3, [e3]);
        this.addPrimitive(p4, [e4]);

        const p5 = new Primitive("Board");

        p5.children[p1.uuid] = p1;
        p5.children[p2.uuid] = p2;
        p5.children[p3.uuid] = p3;
        p5.children[p4.uuid] = p4;

        this.addPrimitive(p2, []);

        // const region = new RegionFace([l1, l2, l3, l4], new Vector3(1, 0, 0));
        // const p1 = new Primitive(PrimitiveType.RegionFace);
        // this.addPrimitive(p1, [region]);
    }

    extrudeSur() {
        const circle = new Circle(new Vector3(0, 0, 0), 20);
        const region = new RegionFace([circle]);
        const transformMatrix = region.transformMatrix;
        const axisZ = new Vector3(0, 0, 1);
        const axisY = new Vector3(0, 1, 0);

        // 创建一个旋转矩阵，绕 Z 轴旋转 -90 度
        const rotationZ = new Matrix4().makeRotationAxis(axisZ, -Math.PI / 2);
        // 创建一个旋转矩阵，绕 Y 轴旋转 90 度
        const rotationY = new Matrix4().makeRotationAxis(axisY, Math.PI / 2);
        const m1 = new Matrix4().premultiply(transformMatrix).premultiply(rotationZ).premultiply(rotationY);
        transformMatrix.copy(m1);
        const ext = new ExtrudeSolid(region, 50);
        const p2 = new Primitive(PrimitiveType.ExtrudeSoild);
        const v = new Vector3(0, 0, 10);
        if (!p2.localModelMatrix) {
            p2.localModelMatrix = new Matrix4();
        }
        v.applyMatrix4(p2.localModelMatrix.clone().invert());
        console.log('v', v)
        ext.offsetDirection = v;
        p2.move(new Vector3(10, 0, 0));
        p2.move(new Vector3(0, 10, 0));
        this.addPrimitive(p2, [ext]);
        // const p1 = new Primitive(PrimitiveType.Circle);
        // const ext = new ExtrudeSurface(circle, new Vector3(10, 0, 10));
        // const p2 = new Primitive(PrimitiveType.ExtrudeSurface);
        // this.addPrimitive(p2, [ext]);
    }

    testFontBox(text: string, fontSize: number, widthRatio: number) {
        let textPrimitive = new TextPrimitive("Text")
        const storage = this.getPythaStorage();
        const font = storage.textStore.font
        if (font == null) return null
        textPrimitive.temporary = true;
        let keys = Object.keys(textPrimitive.renderItemDict);
        if (keys.length <= 0) return null;
        let renderItem = textPrimitive.renderItemDict[keys[0]];
        textPrimitive = textPrimitive;
        textPrimitive.text = text;
        textPrimitive.fontSize = fontSize;
        textPrimitive.widthRatio = widthRatio;

        let offsetX = 0; // 文字偏移 每个文字的起点移到已有文字的最右边
        let geoIndex = 0;
        // 在局部坐标系内解析文字
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            if (char === ' ') {
                // 空格直接偏移
                offsetX += fontSize / 4;
                continue;
            }
            let glyph: Glyph = font.charToGlyph(char);
            if (glyph?.path?.commands?.length <= 0) {
                glyph = font.charToGlyph("?");
            }
            const path = glyph.getPath(0, 0, fontSize);
            const commands = path.commands || [];
            let startX = 0, startY = 0; // 起点
            let x = 0, y = 0; // 当前点
            let maxX = 0; // 解析到的最右侧坐标
            for (let cmd of commands) {
                switch (cmd.type) {
                    case 'M':
                        startX = cmd.x * widthRatio + offsetX;
                        startY = -cmd.y;
                        x = cmd.x * widthRatio + offsetX;
                        y = -cmd.y;
                        break;
                    case 'L':
                    case 'Q':
                    case 'C':
                        x = cmd.x * widthRatio + offsetX;
                        y = -cmd.y;
                        let line = new Line(new Point(startX, startY), new Point(x, y));
                        textPrimitive.geos.push(line);
                        renderItem.geoElements.push(geoIndex);
                        geoIndex++;
                        startX = x;
                        startY = y;
                        break;
                    default:
                        break;
                }
                if (maxX < x) maxX = x;
            }
            offsetX = maxX + 0; // 偏移到最右侧 + 字间距
        }
        let box = textPrimitive.getBoundingbox()
        this.testBoundingBox(box.min, box.max)
        textPrimitive.temporary = false;
        storage.primitiveStore.primitiveDict[textPrimitive.uuid] = textPrimitive;
        textPrimitive.needRedraw = true;
    }

    textGenCircle() {
        let primitive = new Primitive("Circle");
        let circle = new Circle(new Point(1, 1, 1), 1, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        this.addPrimitive(primitive, [circle]);
    }

    textBlockMove() {
        const block = new BlockPrimitive();
        block.blockTemplateUuid = "455f86af-25cc-42ef-8b10-2f26863bd60a";
        this.addPrimitive(block, []);
        const blockMove = block.clone();
        blockMove.move(new Vector3(0, 10, 0));
        this.addPrimitive(blockMove, []);
    }

    circleRender() {
        let circle = new Circle(new Point(0, 0, 0), 50);
        let primitive = new Primitive("circle");
        this.addPrimitive(primitive, [circle]);
    }

    ellipseSurfaceRender() {
        let ellipseFace = new EllipseSurface(new Point(2, 0, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0))
        let primitive = new Primitive("ellipseFace");
        this.addPrimitive(primitive, [ellipseFace]);

    }

    lineRender() {
        // const line = new Line(new Point(20, 0, 0), new Point(80, 0, 0));
        // const line2 = new Line(new Point(60, 80, 0), new Point(60, -80, 0));
        // let primitive = new Primitive("Line");
        // let primitive2 = new Primitive("Line");
        // this.addPrimitive(primitive, [line]);
        // this.addPrimitive(primitive2, [line2]);
        // console.log("primitive", primitive)

        const line3 = new Line(new Point(-40, 0, 0), new Point(-20, 0, 0));
        const line4 = new Line(new Point(-20, 0, 0), new Point(-20, 20, 0));
        const line5 = new Line(new Point(-20, 20, 0), new Point(-40, 20, 0));
        const line6 = new Line(new Point(-40, 20, 0), new Point(-40, 0, 0));
        let primitive3 = new Primitive("Line");
        let primitive4 = new Primitive("Line");
        let primitive5 = new Primitive("Line");
        let primitive6 = new Primitive("Line");
        primitive6.lock = true;
        this.addPrimitive(primitive3, [line3]);
        this.addPrimitive(primitive4, [line4]);
        this.addPrimitive(primitive5, [line5]);
        this.addPrimitive(primitive6, [line6]);

        // const arc = new Arc(new Point(0, 0, 0), 20, Math.PI);
        // const primitive1 = new Primitive("Arc");
        // this.addPrimitive(primitive1, [arc]);

        // const line = new Line(new Point(-20, 0, 0), new Point(20, 0, 0));
        // const primitive2 = new Primitive("Line");
        // this.addPrimitive(primitive2, [line]);

    }

    sweeperRender() {
        const baseCurve = new Circle(new Point(100, 0, 0), 15, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        const sweepPath = new Arc(new Point(20, -40, -20), 50, 90, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        const sweeper = new SweeperSurface(baseCurve, sweepPath);

        let primitiveLine = new Primitive("Line");
        
        let primitive = new Primitive("SweeperSurface");
        let primitiveCircle = new Primitive("Circle");

        

        this.addPrimitive(primitive, [sweeper]);
        this.addPrimitive(primitiveCircle, [baseCurve]);
        this.addPrimitive(primitiveLine, [sweepPath]);

        const baseCurve2 = new Line(new Point(-50, 1, 1), new Point(-100, 1, 1));
        console.log('line transMatrix', baseCurve2.transformMatrix)
        const sweepPath2 = new Arc(new Point(-20, 40, 20), 50, 90, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        // const point = new Point(-75, 1, 1);

        const sweeper2 = new SweeperSurface(baseCurve2, sweepPath2, );
        
        const primitiveLine2 = new Primitive("Line");
        const primitive2 = new Primitive("SweeperSurface")
        const primitiveCircle2 = new Primitive("Circle");

        this.addPrimitive(primitive2, [sweeper2]);
        this.addPrimitive(primitiveCircle2, [baseCurve2]);
        this.addPrimitive(primitiveLine2, [sweepPath2]);

        const sweep3 = new SweeperSurface(baseCurve2, baseCurve);
        const primitive3 = new Primitive("SweeperSurface")
        this.addPrimitive(primitive3, [sweep3])
        
        
    }

    sweeperSolidRender(){
        const rect = new RectFace(new Point(20, 20, 20), new Vector3(10, 0, 0), new Vector3(0, 10, 0));
        console.log('rect transMatrix', rect.transformMatrix)
        const arc = new Arc(new Point(20, -40, -20), 50, 90, new Vector3(0, 0, 1), new Vector3(1, 0, 0));
        const sweeper = new SweeperSolid(rect, arc);

        const primitiveRect = new Primitive("RectFace");
        const primitiveArc = new Primitive("Arc");
        const primitiveSolid = new Primitive("SweeperSolid");
        this.addPrimitive(primitiveArc, [arc]);
        this.addPrimitive(primitiveRect, [rect]);
        this.addPrimitive(primitiveSolid, [sweeper]);
    }

    /**
     * 测试用例-一般体渲染
     */
    bool3Render() {
        const left = new Box(new Point(0, 0, 0), new Point(2, 0, 0), new Point(3, 0, 0), new Point(4, 0, 0));
        const right = new Box(new Point(1, 1, 0), new Point(2, 0, 0), new Point(3, 0, 0), new Point(4, 0, 0));
        let primitiveLeft = new Primitive("left");
        let primitiveRight = new Primitive("right");
        primitiveLeft.geos.push(left);
        primitiveRight.geos.push(right);

        let primitiveBool3 = new Primitive("bool");
        primitiveBool3.leftPrimitive = primitiveLeft;
        primitiveBool3.rightPrimitive = primitiveRight;
        primitiveBool3.boolOpe = BoolOpeType.SUBSTRACT;



        this.addPrimitive(primitiveBool3, []);
    }

    /**
     * 测试用例-一般面域渲染
     */
    generalRegionRender() {
        const generalRegion = new GeneralRegion(
            [
                [new Point(0, 0, 0), new Point(4, 0, 0), new Point(4, 4, 0), new Point(0, 4, 0)],
                [new Point(1, 1, 0), new Point(1, 2, 0), new Point(2, 2, 0), new Point(2, 1, 0)]
            ], new Vector3(0, 0, 1));
        let primitive = new Primitive("Line");
        this.addPrimitive(primitive, [generalRegion]);
        console.log("primitive", primitive)
        console.log("generalRegion", generalRegion)
    }

    /**
     * 测试用例-一般面域渲染
     */
    bool2Render() {
        const left = new GeneralRegion(
            [
                [
                    new Point(0, 0, 0),
                    new Point(3, 0, 0),
                    new Point(3, 3, 0),
                    new Point(0, 3, 0),
                ],
            ], new Vector3(0, 0, 1));

        const right = new RegionFace(
            [
                new Circle(new Point(1, 1, 0), 0.4, new Vector3(0, 0, 1), new Vector3(1, 0, 0))

            ], new Vector3(1, 0, 0), new Point(0, 0, 0));

        console.log("RegionFace", right);

        let primitiveLeft = new Primitive("left");
        let primitiveRight = new Primitive("right");
        primitiveLeft.geos.push(left);
        primitiveRight.geos.push(right);

        let primitiveBool2 = new Primitive("bool");
        primitiveBool2.leftPrimitive = primitiveLeft;
        primitiveBool2.rightPrimitive = primitiveRight;
        primitiveBool2.boolOpe = BoolOpeType.SUBSTRACT;



        this.addPrimitive(primitiveBool2, []);
    }


    /**
     * 测试用例，楔体
     */
    wedgeRender() {
        let geo = new Wedge(new Point(-14.668148271506652, 6.735434324538801, 2), 4.073956329288194,
            25.93477344576968, 22.903569283255806, new Point(-1, 0, 0), new Point(0, 0, 1));
        let primitive = new Primitive("Wedge");
        console.log("geo", geo.getGeoElements())
        this.addPrimitive(primitive, [geo]);
        console.log("primitive", primitive)
    }

    /**
     * 测试用例，旋转体
     */
    revolveSurfaceRender() {
        // 以200，200， 0为旋转轴，旋转一周得到的图形（锥面）
        let revolveSurface1 = new RevolveSurface(new Line(new Point(200, 200, 50), new Point(230, 230, 0)), new StraightLine(new Point(200, 200, 0), new Vector3(0, 0, 1)), 2 * Math.PI);
        let primitive1 = new Primitive("旋转图元");
        this.addPrimitive(primitive1, [revolveSurface1]);


        // 以0，0， 0为旋转轴，旋转一周得到的图形（锥面）
        let revolveSurface2 = new RevolveSurface(new Line(new Point(0, 0, 50), new Point(-70, -70, 0)), new StraightLine(new Point(0, 0, 0), new Vector3(0, 0, 1)), 2 * Math.PI);
        let primitive2 = new Primitive("旋转图元");
        this.addPrimitive(primitive2, [revolveSurface2]);

        // 以0，0， 0为旋转轴，旋转一周得到的图形（锥面）
        let revolveSurface3 = revolveSurface2.clone().rotate(new Point(-50, -50, 0), new Vector3(0, 0, 1), Math.PI / 2);
        let primitive3 = new Primitive("旋转图元");
        this.addPrimitive(primitive3, [revolveSurface3]);

        // 圆环面
        let revolveSurface4 = new RevolveSurface(new Circle(new Point(-300, 300, 0), 30, new Vector3(1, 0, 0), new Vector3(0, 0, 1)), new StraightLine(new Point(-400, 400, 0), new Vector3(0, 0, 1)), 2 * Math.PI);
        let primitive4 = new Primitive("旋转图元");
        this.addPrimitive(primitive4, [revolveSurface4]);
    }

    /**
     * 测试用例 圆环体
     */
    torusRender() {
        let torus5 = new Torus(new Point(0, 0, 0), 50, new Vector3(0, 0, 1), new Vector3(1, 0, 0), 20);
        let primitive5 = new Primitive("Torus");
        this.addPrimitive(primitive5, [torus5]);
    }

    /**
     * 测试椭圆弧
     */
    ellipseArcRender() {
        let ellipseArc1 = new EllipseArc(new Point(2, 0, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0), Math.PI)
        let ellipseArc2 = new EllipseArc(new Point(2, 2, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0), Math.PI * 2)
        let ellipseArc3 = new EllipseArc(new Point(-6, 0, 0), new Vector3(2, 0, 0), new Vector3(0, 1, 0), Math.PI * 3 / 2)
        let primitive5 = new Primitive("ellipseArcs");
        this.addPrimitive(primitive5, [ellipseArc2]);

        const p1 = ellipseArc2.getPointAt(0);
        const p2 = ellipseArc2.getPointAt(0.25);
        const p3 = ellipseArc2.getPointAt(0.5);
        const p4 = ellipseArc2.getPointAt(0.75);
        const c1 = ellipseArc2.getCutLineDir(p1);
        const c2 = ellipseArc2.getCutLineDir(p2);
        const c3 = ellipseArc2.getCutLineDir(p3);
        const c4 = ellipseArc2.getCutLineDir(p4);

        const l1 = new Line(p1, p1.clone().add(c1.multiplyScalar(10)));
        const l2 = new Line(p2, p2.clone().add(c2.multiplyScalar(10)));
        const l3 = new Line(p3, p3.clone().add(c3.multiplyScalar(10)));
        const l4 = new Line(p4, p4.clone().add(c4.multiplyScalar(10)));

        const pr1 = new Primitive("Line");
        const pr2 = new Primitive("Line");
        const pr3 = new Primitive("Line");
        const pr4 = new Primitive("Line");
        this.addPrimitive(pr1, [l1]);
        this.addPrimitive(pr2, [l2]);
        this.addPrimitive(pr3, [l3]);
        this.addPrimitive(pr4, [l4]);
    }

    /**
     * 测试包围盒
     */
    testBoundingBox(min: Vector3, max: Vector3) {
        // 创建点
        const p1 = new Point(min.x, min.y, min.z); // 000
        const p2 = new Point(max.x, min.y, min.z); // 100
        const p3 = new Point(max.x, max.y, min.z); // 110
        const p4 = new Point(min.x, max.y, min.z); // 010

        const p5 = new Point(min.x, min.y, max.z); // 001
        const p6 = new Point(max.x, min.y, max.z); // 101
        const p7 = new Point(max.x, max.y, max.z); // 111
        const p8 = new Point(min.x, max.y, max.z); // 011

        // 创建边线
        const lines = [
            // 底面
            new Line(p1, p2),
            new Line(p2, p3),
            new Line(p3, p4),
            new Line(p4, p1),

            // 顶面
            new Line(p5, p6),
            new Line(p6, p7),
            new Line(p7, p8),
            new Line(p8, p5),

            // 竖直线
            new Line(p1, p5),
            new Line(p2, p6),
            new Line(p3, p7),
            new Line(p4, p8),
        ];
        let primitive = new Primitive("boundingBox");
        this.addPrimitive(primitive, [...lines])
    }

    /**
     * 测试截面
     */
    sectionRender() {
        // const section = {
        //     type: "槽钢",
        //     paramIn: {
        //         h: 0.05,
        //         b: 0.037,
        //         t_w: 0.0045,
        //         t_f: 0.007
        //     }
        // };
        const section = {
            paramIn: {
                h: 0.1,
                b: 0.068,
                t_w: 0.0045,
                t_f: 0.0076
            }
        };
        // const section = {
        // let sectionFaces = SectionTools.getRegionFaceBySection(1, section);
        // console.log(sectionFaces);
        // let primitive = new Primitive("RegionFace");
        // // primitive.rotate(new Vector3(0, 0, 0), new Vector3(1, 0, 0), Math.PI / 2);

        // // this.addPrimitive(primitive, sectionFaces);

        // const region = sectionFaces[0].clone();

        // const transformMatrix = region.transformMatrix;
        // const axisZ = new Vector3(0, 0, 1);
        // const axisY = new Vector3(0, 1, 0);

        // // 创建一个旋转矩阵，绕 Z 轴旋转 -90 度
        // const rotationZ = new Matrix4().makeRotationAxis(axisZ, -Math.PI / 2);
        // // 创建一个旋转矩阵，绕 Y 轴旋转 -90 度
        // const rotationY = new Matrix4().makeRotationAxis(axisY, -Math.PI / 2);
        // const m1 = new Matrix4().premultiply(transformMatrix).premultiply(rotationZ).premultiply(rotationY);
        // transformMatrix.copy(m1);
        // const extP = new ExtrudeSolid(region, 10);
        // // extP.move(new Vector3(50, 0, 0));
        // const newP = new Primitive(PrimitiveType.ExtrudeSoild);
        // newP.move(new Vector3(50, 0, 0))

        // const p1 = new Vector3(0, 50, 0);
        // const p2 = new Vector3(50, 0, 0);
        // const vec = new Vector3().subVectors(p1, p2);
        // const angle = GeoRelation.Vector3AngleTo(new Vector3(1, 0, 0), vec, new Vector3(0, 0, 1));
        // console.log('angle', angle);

        // newP.rotate(p2, new Vector3(0, 0, 1), angle);
        // extP.height = 50;
        // console.log('first', extP.getNormalizeX().applyMatrix4(newP.worldModelMatrix))
        // console.log('first2', extP.getNormalizeY().applyMatrix4(newP.worldModelMatrix))
        // console.log('first3', extP.getNormalizeZ().applyMatrix4(newP.worldModelMatrix));
        // console.log('first', extP.getNormalizeX().applyMatrix4(newP.localModelMatrix))
        // console.log('first2', extP.getNormalizeY().applyMatrix4(newP.localModelMatrix))
        // console.log('first3', extP.getNormalizeZ().applyMatrix4(newP.localModelMatrix));
        // console.log('getP', extP.getP().applyMatrix4(newP.localModelMatrix));
        // console.log('getP', extP.getP().applyMatrix4(newP.worldModelMatrix));
        // this.addPrimitive(newP, [extP]);
    }

    /**
     * 模拟轴网
     */
    mockAxis() {
        const primitive = new Primitive("AxisNet");
        const l1 = new Line(new Vector3(0, 0, 0), new Vector3(10, 0, 0));
        const l2 = new Line(new Vector3(10, 0, 0), new Vector3(10, 10, 0));
        const l3 = new Line(new Vector3(10, 10, 0), new Vector3(0, 10, 0));
        const l4 = new Line(new Vector3(0, 10, 0), new Vector3(0, 0, 0));
        const p1 = new Primitive("AxisLine");
        const p2 = new Primitive("AxisLine");
        const p3 = new Primitive("AxisLine");
        const p4 = new Primitive("AxisLine");
        // primitive.setChildren([p1, p2, p3, p4]);
        this.addPrimitive(p1, [l1]);
        this.addPrimitive(p2, [l2]);
        this.addPrimitive(p3, [l3]);
        this.addPrimitive(p4, [l4]);
        // this.addPrimitive(primitive, []);
    }

}



export function addPrimitive(primitive: Primitive, geos: GeometryBase[], storage: any) {
    primitive.geos.push(...geos);
    let keys = Object.keys(primitive.renderItemDict);
    if (keys.length > 0) {
        let renderItem = primitive.renderItemDict[keys[0]];
        renderItem.geoElements = [];
        geos.forEach(geo => {
            let geoElementsLength = renderItem.geoElements.length;
            geo.getGeoElementsIdxList().forEach(idx => {
                renderItem.geoElements.push(idx + geoElementsLength);
            })
        });
        if (primitive.isBoolPrimitive()) {
            primitive.renderItemDict[keys[0]].geoElements = [];
            primitive.renderItemDict[keys[0]].geoElements.push(0);
        }
    }

    primitive.temporary = false;
    storage.primitiveStore.primitiveDict[primitive.uuid] = primitive;
    primitive.needRedraw = true;
}

